// Shown after "Delete my account": the server erased the profile and ended
// every session; the access token is forgotten here too.
import { Anchor, Text } from "@mantine/core";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { clearSession } from "../../shared/session/session";
import { Page } from "../../shared/ui/Page";

export function AccountDeletedPage() {
  const { t } = useTranslation();
  const signOut = (useLocation().state as { signOut?: boolean } | null)?.signOut === true;
  useEffect(() => {
    if (signOut) clearSession();
  }, [signOut]);
  return (
    <Page title={t("account_deleted.title")}>
      <Text data-testid="account-deleted">{t("account_deleted.body")}</Text>
      <Text size="sm">{t("account_deleted.sms")}</Text>
      <Text size="sm">{t("account_deleted.code")}</Text>
      <Anchor component={Link} to="/">
        {t("account_deleted.home")}
      </Anchor>
    </Page>
  );
}
